import { render, staticRenderFns } from "./TopPlacements.vue?vue&type=template&id=ccffb38e&scoped=true&"
import script from "./TopPlacements.vue?vue&type=script&lang=js&"
export * from "./TopPlacements.vue?vue&type=script&lang=js&"
import style0 from "./TopPlacements.vue?vue&type=style&index=0&id=ccffb38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccffb38e",
  null
  
)

export default component.exports